<template>
  <div class="main full-height">
    <div class="legal-content frosted">
      <button class="back-button-top" @click="$router.back()">
        <img src="@/assets/images/back.svg" alt="Zurück">
        <span>Zurück</span>
      </button>
      
      <h1>Allgemeine Geschäftsbedingungen (AGB)</h1>
      <p class="last-update">Stand: März 2026</p>

      <section>
        <h2>1. Geltungsbereich</h2>
        <p>Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der App "Clink" (nachfolgend "App"). Durch die Registrierung und Nutzung der App erklären Sie sich mit diesen Bedingungen einverstanden.</p>
      </section>

      <section>
        <h2>2. Leistungen der App</h2>
        <p>Clink ist eine Plattform zur Dokumentation und zum Vergleich von Getränkekonsum innerhalb privater Gruppen. Die App bietet Funktionen wie Rankings, Statistiken und Gruppenmanagement.</p>
        <p>Einige Funktionen (z.B. erweiterte Statistiken) sind kostenpflichtig ("Premium").</p>
      </section>

      <section>
        <h2>3. Registrierung und Konto</h2>
        <p>Für die Nutzung der App ist die Erstellung eines Kontos erforderlich. Sie sind verpflichtet, Ihre Zugangsdaten geheim zu halten. Ein Anspruch auf Registrierung besteht nicht.</p>
      </section>

      <section>
        <h2>4. Kostenpflichtige Dienste (Premium)</h2>
        <p>Der Erwerb von Premium-Funktionen erfolgt über Drittanbieter (z.B. Stripe). Es gelten die dortigen Zahlungsbedingungen. Eine Rückerstattung für bereits genutzte Zeiträume ist ausgeschlossen, sofern nicht gesetzlich anders vorgeschrieben.</p>
      </section>

      <section>
        <h2>5. Nutzerpflichten und Verhaltensregeln</h2>
        <p>Die Nutzer verpflichten sich, die App nicht missbräuchlich zu verwenden. Insbesondere ist das Einstellen von rechtswidrigen Inhalten untersagt. Wir behalten uns vor, Nutzer bei Verstößen gegen diese AGB von der Nutzung auszuschließen.</p>
      </section>

      <section>
        <h2>6. Haftung</h2>
        <p>Wir haften für Schäden nur bei Vorsatz oder grober Fahrlässigkeit. Die Nutzung der App erfolgt auf eigene Gefahr. Insbesondere übernehmen wir keine Haftung für gesundheitliche Folgen, die aus der Dokumentation oder dem Vergleich von Alkoholkonsum resultieren könnten. Wir rufen ausdrücklich zu einem verantwortungsvollen Umgang mit Alkohol auf.</p>
      </section>

      <section>
        <h2>7. Schlussbestimmungen</h2>
        <p>Es gilt das Recht der Bundesrepublik Deutschland. Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.</p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfServiceView'
}
</script>

<style scoped>
.main {
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--background);
}

.legal-content {
  max-width: 800px;
  width: 100%;
  padding: 30px;
  text-align: left;
  line-height: 1.6;
}

.back-button-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
}

.back-button-top img {
  width: 20px;
  filter: var(--icon-filter);
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 10px;
}

h2 {
  font-size: 1.2rem;
  margin-top: 25px;
  margin-bottom: 10px;
  color: var(--primary-color);
}

.last-update {
  color: var(--tertiary-color);
  font-size: 0.9rem;
  margin-bottom: 30px;
}

section {
  margin-bottom: 20px;
}

p {
  margin-bottom: 15px;
  color: var(--primary-color);
  opacity: 0.9;
}
</style>
